import { compose } from '@beef/redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { selectCurrentBanner, selectIsRenderBanner, withBannersMapper } from "../../../../store/slices/search/selectors";
import { BannerGroup } from "./BannerGroup";
import { Banner } from "./Banner";
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    shouldRender: props.shouldRender && selectIsRenderBanner(state)
  };
};
export var BannerGroupMapper = compose(connect(mapStateToProps), withBannersMapper, withRenderFlag)(BannerGroup);
export var BannerRC = connect(function (state) {
  return {
    url: selectCurrentBanner(state).url,
    title: selectCurrentBanner(state).title,
    imageUrl: selectCurrentBanner(state).imageUrl
  };
})(Banner);